<template>
  <v-dialog v-model="dialog" max-width="1000px">
    <v-card v-if="dialog" class="pa-2">
      <div class="d-flex mb-2">
        <span class="text-h6">Comunicados</span>

        <v-spacer />

        <v-btn icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-carousel hide-delimiter-background>
        <v-carousel-item
          v-for="(item, i) in banners"
          :key="i"
          :href="item?.toURL"
          :src="item?.imageURL"
          target="_blank"
          class="rounded-lg"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
        </v-carousel-item>
      </v-carousel>
    </v-card>
  </v-dialog>
</template>

<script>
import { getBanners } from "@/services/banners";
import { handleAlert } from "@/utils";

export default {
  name: "BannerDialog",

  data() {
    return {
      dialog: false,
      banners: [],
    };
  },

  created() {
    this.getBanners();
  },

  methods: {
    async getBanners() {
      try {
        const payload = { active: true };

        const { data } = await getBanners(payload);

        if (!data.length) return;

        this.banners = data;
        this.dialog = true;
      } catch (error) {
        this.handleAlert(error?.data?.message || error?.message, "error");
      }
    },

    handleAlert,
  },
};
</script>

<style></style>
